export default class Catalog {
  constructor(catalog) {
    this.id = catalog.id;
    this.sections = catalog.sections;
    this.recommendedCatalogPages = catalog.recommendedCatalogPages;
  }

  get orderedSections() {
    return [...this.sections].sort((a, b) => a.order > b.order ? 1 : -1);
  }
}